import { LOCALES } from '../config/locales';
import { Post } from '../types/post';

export const getLocalePost = (post: Post, locale: LOCALES | undefined) => {
  if (!post.localePosts || !locale) return;
  return post.localePosts.find((_) => _.locale === locale);
};
